import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CoreModule } from '../core/core.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TasksPage } from './tasks.page';
import { TasksRoutingModule } from './tasks-routing.module';
import { SharedJobDetailsModule } from '../projects/project-details/project-jobs/shared-job-details.module';
import { TranslatePipe } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { Tag } from 'primeng/tag';
import { TaskDetailsComponent } from './task-details/task-details.component';
import { ProjectListModule } from '../projects/project-list/project-list.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TasksRoutingModule,
        FontAwesomeModule,
        CoreModule,
        NgSelectModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        SharedJobDetailsModule,
        TranslatePipe,
        TableModule,
        Tag,
        ProjectListModule,
    ],
    providers: [],
    declarations: [TasksPage, TaskDetailsComponent],
    exports: [TasksPage, TaskDetailsComponent],
})
export class TasksModule {}
